import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function ResearchPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Key Research Management"
        subtitle="Manage key research areas and homepage cards"
        contentType="research"
        fields={[
          // Basic Information
          { name: 'title', label: 'Research Title', type: 'text', required: true, placeholder: 'e.g., SMART BREEDING FOR CLIMATE RESILIENCE' },
          { name: 'excerpt', label: 'Short Excerpt', type: 'textarea', placeholder: 'Brief description shown on cards (1-2 lines)' },
          { name: 'description', label: 'Full Description', type: 'richtext', hint: 'Detailed content with formatting' },
          
          // Media & Links
          { name: 'image_file', label: 'Research Image', type: 'file', fileType: 'image', hint: 'Upload research area image (JPG, PNG, WEBP)' },
          { name: 'image_url', label: 'Or Image URL (if not uploading)', type: 'text', placeholder: 'https://example.com/image.jpg' },
          { name: 'link_url', label: 'Link URL', type: 'text', placeholder: '/research/climate-resilience or https://external-link.com' },
          
          // Display Settings
          { name: 'is_key_research', label: 'Show on Homepage', type: 'checkbox', defaultValue: true, checkboxLabel: 'Display in Key Research section on homepage' },
          { name: 'priority', label: 'Priority (Ordering)', type: 'number', defaultValue: 10, min: 0, max: 100, hint: 'Higher priority = shown first. Top priority gets "Featured" badge' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['title', 'priority', 'is_key_research', 'is_published']}
      />
    </AdminLayout>
  );
}
